<template>
  <v-row dense>
    <v-col cols="12">
      <app-title
        texto="FORMAÇÃO"
        class="ml-5"
      />
    </v-col>
    <v-col cols="6">
      <filtro-formacao-academica
        @return="(value) => $emit('formacaoAcademica', value)"
      />
    </v-col>
    <v-col cols="6">
      <filtro-formacao-complementar
        @return="(value) => $emit('formacaoComplementar', value)"
      />
    </v-col>
  </v-row>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import FiltroFormacaoAcademica from '@/components/monitoramento/perfil/filtro/FiltroFormacaoAcademica';
import FiltroFormacaoComplementar from '@/components/monitoramento/perfil/filtro/FiltroFormacaoComplementar';

export default {
  name: 'FiltroFormacao',

  components: { AppTitle, FiltroFormacaoAcademica, FiltroFormacaoComplementar },
};
</script>
